export default [
  {
    name: 'Forbes',
    logo: require('@/assets/partners/forbes.svg'),
    href: '#'
  },
  {
    name: 'Fortum',
    logo: require('@/assets/partners/fortum.svg'),
    href: '#'
  },
  {
    name: 'ВТБ',
    logo: require('@/assets/partners/vtb.svg'),
    href: '#'
  },
  {
    name: 'Сбер',
    logo: require('@/assets/partners/sber.svg'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/dixy.svg'),
    href: '#'
  }
]
